/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbCalendrierGridDto } from './FcbCalendrierGridDto';
import {
    FcbCalendrierGridDtoFromJSON,
    FcbCalendrierGridDtoFromJSONTyped,
    FcbCalendrierGridDtoToJSON,
} from './FcbCalendrierGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbCalendrierGridDtoPaginatedResults
 */
export interface FcbCalendrierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbCalendrierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbCalendrierGridDto>}
     * @memberof FcbCalendrierGridDtoPaginatedResults
     */
    results?: Array<FcbCalendrierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbCalendrierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbCalendrierGridDtoPaginatedResults interface.
 */
export function instanceOfFcbCalendrierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbCalendrierGridDtoPaginatedResultsFromJSON(json: any): FcbCalendrierGridDtoPaginatedResults {
    return FcbCalendrierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbCalendrierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbCalendrierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbCalendrierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbCalendrierGridDtoPaginatedResultsToJSON(value?: FcbCalendrierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbCalendrierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

